import { defineComponent as _defineComponent } from 'vue'
import AccountAvatar from '@/components/views/main/AccountAvatar.vue';

import { computed, ref, watch } from 'vue';
import i18n from '@/plugins/i18n';
import { performAction } from '@/services/vue-utils';
import store from '@/store/store';
import { startAutoUpdates, stopAutoUpdates } from '@/services/autoupdater';
import { startTodayUpdatesAsync } from '@/services/now-updater';
import UserAccount from '@/model/UserAccount';
import { useRouter } from 'vue-router/composables';
import scrollIntoView from 'scroll-into-view-if-needed';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountSwitcher',
  props: {
  miniVariant: { type: Boolean, required: false, default: false },
  collapsable: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;

const router = useRouter();


const switcherActive = ref(false);

const newAccountName = ref(null as string | null);
const accountName = computed(() => store.state.settings.account.accountName ?? newAccountName.value ?? '');

const newUserName = ref(null as string | null);
const userName = computed(() => store.state.settings.account.username || newUserName.value || '');

const accounts = computed(() => store.getters.userAccounts);

const accountColor = computed(() => store.state.settings.account.color ?? 'brand');

const currentAccountId = computed(() => store.state.settings.account.id);

watch(switcherActive, () => {
  if (!switcherActive.value) { return; }
  setTimeout(() => {
    const elm = document.getElementById(`account_switcher_li_${currentAccountId.value}`);
    if (elm === null) { return; }

    scrollIntoView(elm, {
      behavior: 'auto',
      scrollMode: 'if-needed',
      block: 'center',
    });
  }, 100);
});

const changeAccount = async (a: UserAccount) => {
  newAccountName.value = a.accountName;
  newUserName.value = store.state.settings.account.username ?? '';

  await performAction(
    null,
    i18n.tc('error.load_data'),
    async () => {
      await stopAutoUpdates();
      store.dispatch('switchAccount', { id: a.id, token: a.token, userName: newUserName.value });
      router.go(0);
      await startTodayUpdatesAsync();
      await startAutoUpdates();
    },
  );
};


return { __sfc: true,router, props, switcherActive, newAccountName, accountName, newUserName, userName, accounts, accountColor, currentAccountId, changeAccount, AccountAvatar }
}

})